// extracted by mini-css-extract-plugin
export default {"dropdown":"ManagePositionsCardDropdown_dropdown__6n66-"};